<div class="page-wrapper">
  <div class="content">
    <app-page-content style="--page-content-width: var(--page-content-max-width-anonymous-pages); --page-content-gap: var(--size-xl)">
      <app-swipes-logo class="logo" style="--swipes-logo-scale-factor: 1.5"></app-swipes-logo>
      <ng-content></ng-content>
    </app-page-content>
  </div>
  <!--  <footer class="footer">-->
  <!--    <div class="language-switcher">-->
  <!--      <a-->
  <!--        class="language"-->
  <!--        *ngFor="let language of languages"-->
  <!--        (click)="switchLanguage(language, $event)"-->
  <!--        href="#"-->
  <!--        [ngClass]="{ '-active': isActiveLanguage(language) }"-->
  <!--      >-->
  <!--        {{ language | uppercase }}-->
  <!--      </a>-->
  <!--    </div>-->
  <!--  </footer>-->
</div>
